import { TableNames } from "../../enums/tableNames";
import WorklistPage from "./components/worklistPage";
import { CallingWorklistView } from "./utils/buildWorklistFilters";

/**
 * Pending worklist: orders the pipeline flagged with `epa_pending_required: [yes]`.
 * Independent of the non-ePA list and of the payer response status.
 */
const PendingWorklist = () => (
  <WorklistPage
    heading="Pending Orders"
    view={CallingWorklistView.PENDING}
    tableName={TableNames.PENDING_WORKLIST_ORDERS}
  />
);

export default PendingWorklist;
